import React from 'react'
import Splash from './Splash/Splash'
import Footer from './Footer/Footer'
import Navigation from './Navigation/Navigation'

interface LayoutProps {
  loading: boolean
  authorized: boolean
  onLogOut?: () => void
  hideHeader?: boolean
  hideFooter?: boolean
}

const Layout: React.FC<LayoutProps> = ({
  children,
  loading,
  authorized,
  onLogOut,
  hideHeader = false,
  hideFooter = false,
}) => {
  return (
    <>
      {!hideHeader && <Navigation authorized={authorized} onLogOut={onLogOut} />}
      <div className="min-h-screen">{!loading ? children : null}</div>
      <Splash show={loading} />
      {!hideFooter && <Footer />}
    </>
  )
}

export default Layout
